export default __webpack_public_path__ + "static/clients-258b156099913b8bf10289978f0abc26.webp";